import React from 'react';
import { Building2, Home, Calendar, Users } from 'lucide-react';
import { t } from '../../i18n/languages';

function StatsCards({ stats, currentLanguage }) {
  return (
    <div style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
      gap: '16px', 
      marginBottom: '32px' 
    }}>
      {/* In Office Today */}
      <div style={{ 
        background: 'white', 
        padding: '20px', 
        borderRadius: '12px', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)' 
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
              {t('inOfficeToday', {}, currentLanguage)}
            </p>
            <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#3b82f6' }}>
              {stats.inOffice}
            </p>
          </div>
          <Building2 size={32} color="#3b82f6" />
        </div>
      </div>
      
      {/* Working from Home */}
      <div style={{ 
        background: 'white', 
        padding: '20px', 
        borderRadius: '12px', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)' 
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
              {t('workingFromHome', {}, currentLanguage)}
            </p>
            <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#10b981' }}>
              {stats.workingFromHome}
            </p>
          </div>
          <Home size={32} color="#10b981" />
        </div>
      </div>
      
      {/* On Leave */}
      <div style={{ 
        background: 'white', 
        padding: '20px', 
        borderRadius: '12px', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)' 
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
              {t('onLeave', {}, currentLanguage)}
            </p>
            <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#f59e0b' }}>
              {stats.onLeave}
            </p>
          </div>
          <Calendar size={32} color="#f59e0b" />
        </div>
      </div>
      
      {/* Total Team */}
      <div style={{ 
        background: 'white', 
        padding: '20px', 
        borderRadius: '12px', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)' 
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>
              {t('totalTeam', {}, currentLanguage)}
            </p>
            <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#6b7280' }}>
              {stats.total}
            </p>
          </div>
          <Users size={32} color="#6b7280" />
        </div>
      </div>
    </div>
  );
}

export default StatsCards;
